// removed by extract-text-webpack-plugin
module.exports = {"container":"_3guS","description":"DENf","wrapper":"tG_Y","textContainer":"_1eqg","title":"st11","imageContainer":"_3ygR","image":"_3LSC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CaseStudiesPage/Hero/styles.scss
// module id = 517
// module chunks = 0